import type { TripListRow } from './tripListTypes'

const CSV_HEADERS = ['Type', 'Title', 'Location', 'Day', 'Notes', 'Price', 'Action'] as const

function escapeCsvValue(value: string | number | undefined): string {
  if (value === undefined) return ''
  const stringValue = String(value)
  if (!/[",\n\r]/.test(stringValue)) return stringValue
  return `"${stringValue.replace(/"/g, '""')}"`
}

function getPriceText(row: TripListRow): string | undefined {
  if (row.price.price !== undefined) {
    return [
      row.price.currency,
      row.price.price,
      row.price.saleUnit ? `/${row.price.saleUnit}` : undefined,
    ].filter(Boolean).join(' ')
  }

  return row.price.priceLevel ?? undefined
}

export function buildTripListCsv(rows: Array<TripListRow>): string {
  const csvRows = [
    CSV_HEADERS.join(','),
    ...rows.map(row => [
      row.typeLabel,
      row.title,
      row.stop.placeName,
      row.day?.dayNumber,
      row.note,
      getPriceText(row),
      row.isBooked ? 'View booking' : row.isBookable ? 'Book' : undefined,
    ].map(escapeCsvValue).join(',')),
  ]

  return csvRows.join('\n')
}
